import { HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CalTokenService } from '../services/security/cal-token.service';

/**
 * Allowlist explícita de hosts permitidos para Microsoft Graph.
 * Evita checks tipo startsWith/includes/endsWith sobre strings de URL
 * (CodeQL: js/incomplete-url-substring-sanitization).
 */
const GRAPH_ALLOWED_HOSTS = new Set<string>([
  'graph.microsoft.com',
]);

function isMicrosoftGraphRequest(urlStr: string): boolean {
  try {
    const url = new URL(urlStr, window.location.origin);

    return url.protocol === 'https:' && GRAPH_ALLOWED_HOSTS.has(url.hostname);
  } catch {
    return false;
  }
}

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const calTokenService = inject(CalTokenService);

  if (req.headers.has('Authorization')) {
    return next(req);
  }

  if (isMicrosoftGraphRequest(req.url)) {
    return next(req);
  }

  const apiScope = `${environment.audience}/user_impersonation`;

  return from(calTokenService.getAccessToken([apiScope])).pipe(
    switchMap((accessToken) => {
      if (!accessToken) {
        return next(req);
      }

      const authenticatedRequest = req.clone({
        setHeaders: { Authorization: `Bearer ${accessToken}` }
      });

      return next(authenticatedRequest);
    }),
    catchError(() => next(req))
  );
}